var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex flex-col items-center"},_vm._l((_vm.resultList),function(item,index){return _c('menu-item',{key:index,attrs:{"item":item},on:{"click":function($event){return _vm.$emit('menu', item)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }